import {getCookie, setCookie} from 'tiny-cookie';
import {ALL_ALTERNATIVES} from '@/services/defineService';

const FLAGS = {
  // This is set when browser is IE11, ie not capable of modern web
  // functionality. We restrict features + show message based on this.
  legacy: {default: false},

  // voucher to auto-apply to cart.
  voucher: {default: ''},


  // #region Almost done

  // Enable team import
  // Todo: rollout
  enableTeamMembersImport: {default: false},

  // Allow picking the people being ordered for to fill
  // in template
  // Todo: finish bugs, decide how to roll out
  startOrderDropdown: {default: false},

  // #endregion

  // #region WIP marketing pages

  // Enable WIP features page
  featuresPage: {default:false},

  // #endregion


  // #region debug/for developers
  // Enable debug toolbar
  debugTools: {default: false},

  // Debug tool to remove user (not just teamuser)
  enableDeleteUser: {default: false},

  // Enable debugging onboarding
  forceOnboarding: {default: false},

  // Nametags stuff
  showUncategorizedTemplates: {default: false},

  // #endregion


  // #region WIP editor UIs

  // Enable upload of back file without refreshing. This
  // is buggy.
  seamlessBackUpload: {default: false},

  // Enables block creation logic
  // Todo: polish UI
  enableBlocks:{default:false},

  // Enables field options
  // Todo: work on UI
  enableFieldOptions: {default: false},

  // Enables the lock template feature for template editor
  // Todo: just enable for everyone
  enableLockTemplate: {default: false},

  // Enables the superscript option
  // Todo: make behavior more intuitive (should act like a toggle)
  enableSuperscript: {default: false},

  // Enables SVG upload, which has bad production characteristics
  svgUpload: {default: false},

  // Enables button on template editor
  // Todo: decide if we need the button
  toggleCropBleed: {default:false},

  // Use filestack for upload? Allows cropping
  // Todo: find limitations, pricing, decide on use
  filestackUpload: {default:false},

  // #endregion


  // #region WIP ordering UI

  // WIP Emails settings section. Too sparse to publish.
  enableEmailsSettings: {default: false},

  // WIP option to verify addresses in checkout screen.
  // This doesn't surface the errors very well.
  verifyCheckoutShippingAddressData: {default: false},

  // Enable international shipping options on checkout.
  // Still experimental (have to explain AQ, etc)
  internationalShipping: {default: false},

  // #endregion


  // #region WIP dashboard UI

  // WIP team list - show last order date
  // This can't be rolled out until team/teamuser is backfilled
  showLastOrderDate: {default: false},

  // WIP UI for adding discount on approval
  // TODO: finish polish and roll out
  enableDiscountApplying: {default: false},

  // WIP option to edit design during approval.
  // The workflow is not smooth, and we don't keep
  // a good change log.
  approvalEditDesign: {default: false},

  // Option to unlock design when editing. Not sure
  // if this should be default. Some workflows may
  // want reviewer to stick to content edits, ie keep
  // the locked design.
  approvalEditDesignUnlocks: {default: false},

  // This enables re-order.
  // Todo: rename (involves migrating a customer..)
  // Todo: test out automatic design update?
  showUnimplementedOrderActions: {default: false},

  // Remove Team tab for orderers
  showTeamTabToOrderers: {default: false},

  // #endregion
};

function defaults() {
  let result = {};
  for (let k in FLAGS) {
    result[k] = FLAGS[k].default;
  }
  if (URLS.STATIC) Object.assign(result, ALL_ALTERNATIVES);
  if (process.env.LEGACY) result.legacy = true;
  return result;
}

function cleanFlags(flags) {
  // Return a clean version (non-default values only)
  let result = {};
  for (let key in flags) {
    let defaultValue = (FLAGS[key] || {default: false}).default;
    if (flags[key] !== defaultValue) result[key] = flags[key];
  }
  return result;
}

let loadedFlags = {};
try {
  loadedFlags = getCookie('flags', JSON.parse) || {};
} catch(e) {
  console.error(e);
}
// Allow other scripts to set flags without having access to Vue.
// Code should do:
// (window._appFlags||(window._appFlags=[])).push({getStartedSignup: true})
if (window._appFlags) {
  Object.assign(loadedFlags, ...window._appFlags);
  console.log('window._appFlags loaded', window._appFlags);
}
// Install "reactive" version
window._appFlags = [];
window._appFlags.push = (value) => {
  window.VueApp.$store.dispatch('updateFlags', value);
}

export default {
  state: {
    flags: Object.assign({}, defaults(), loadedFlags),
    needsReload: false
  },
  mutations: {
    setFlags(state, flags) {
      for (let flag in flags) {
        // If flag is defined to need reload and we're changing the value,
        // user needs to reload
        if (FLAGS[flag] && FLAGS[flag].reload && flags[flag] != state.flags[flag]) {
          state.needsReload = true;
        }
      }
      state.flags = flags
      console.log('flags->', state.flags, 'needsReload->', state.needsReload);
    }
  },
  actions: {
    async updateFlags({commit, state, dispatch}, updates) {
      commit('setFlags', Object.assign({}, state.flags, updates));
      setCookie('flags', state.flags, JSON.stringify);
      commit('setFutureVoucher', state.flags.voucher||'');
    },
    async resetFlags({dispatch, commit}) {
      setCookie('flags', "{}");
      commit('setFlags', defaults());
      dispatch('setTeamFlags');
    }
  },
  getters: {
    flags: state => ({...defaults(), ...state.flags}),
    cleanFlags: state => cleanFlags(state.flags),
    needsReload: state => state.needsReload
  }
}



// WEBPACK FOOTER //
// ./src/store/flags.js